import { useState, useEffect } from 'react';

// Hook para detectar se é dispositivo móvel
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Verifica se é mobile baseado na largura da tela e user agent
      const isMobileWidth = window.innerWidth <= 768;
      const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      
      setIsMobile(isMobileWidth || isMobileUserAgent);
    };

    // Verifica inicialmente
    checkIsMobile();

    // Adiciona listener para mudanças de tamanho da tela
    window.addEventListener('resize', checkIsMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return isMobile;
};

// Hook para configurações de gráfico responsivo
export const usePlotlyConfig = () => {
  const isMobile = useIsMobile();

  const getPlotlyConfig = () => {
    const baseConfig = {
      displaylogo: false,
      modeBarButtonsToRemove: ['zoomIn', 'zoomOut2d', 'lasso2d', 'select2d', 'autoScale2d', 'pan2d', 'zoom2d']
    };

    if (isMobile) {
      return {
        ...baseConfig,
        // Desabilita interações de zoom em mobile
        scrollZoom: false,
        doubleClick: false,
        showTips: false,
        // Remove todos os botões da toolbar em mobile
        displayModeBar: false
      };
    }

    return baseConfig;
  };

  const getPlotlyLayout = (existingLayout = {}) => {
    if (isMobile) {
      return {
        ...existingLayout,
        // Desabilita zoom e pan em mobile
        dragmode: false,
        scrollZoom: false,
        doubleClick: false,
        // Configurações adicionais para mobile
        margin: {
          l: 40,
          r: 20,
          t: 40,
          b: 40,
          ...existingLayout.margin
        }
      };
    }

    return existingLayout;
  };

  return { getPlotlyConfig, getPlotlyLayout, isMobile };
};
